import styled from 'styled-components';

export const Title = styled.h1`
  position: relative;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #333;
  text-align: left;
`;
